import {
  AMLIN_APPLICATION_CORRESPONDENCE_ADDRESS,
  AMLIN_VEHICLE_OVERNIGHT_ADDRESSES,
} from './amlin-horsebox-api.constants';

export function getVehicleOvernightLines(v: any): string[] {
  const k = AMLIN_VEHICLE_OVERNIGHT_ADDRESSES;
  const arr = (v?.[k] && Array.isArray(v[k]))
    ? v[k]
    : (v?.overnight_addresses && Array.isArray(v.overnight_addresses) ? v.overnight_addresses : []);
  if (arr.length) {
    return arr.map((a: any) =>
      [a.line1, a.line2, a.line3, a.town, a.county, a.postcode].filter(Boolean).join(', ')
    );
  }
  if (v?.postcode) return [String(v.postcode)];
  return [];
}

export function isKeptOvernightAtProposer(v: any): boolean {
  return getVehicleOvernightLines(v).length === 0;
}

export function getCorrespondenceLine(app: any): string | null {
  const ca = app?.[AMLIN_APPLICATION_CORRESPONDENCE_ADDRESS] ?? app?.correspondence_address;
  if (!ca || (!(ca.line1 || '').trim() && !(ca.postcode || '').trim())) return null;
  return [ca.line1, ca.line2, ca.line3, ca.town, ca.county, ca.postcode]
    .filter((x: string) => (x || '').trim())
    .join(', ');
}
